/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Pelumi's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Nofiu Pelumi Portfolio",
    type: "website",
    url: "https://nofiupelumi.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Nofiu Pelumi",
  logo_name: "Nofiu Pelumi",
  nickname: "Pelumi",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/15-Y89AHzMdpKnfB9GgJOWxDzF5JG1-nz/view?usp=sharing",
  //portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/nofiupelumi",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/nofiupelumi",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/nofiumoruf/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/peldargacademy",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:nofiumoruf17@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/morufnofiu",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/nofiumoruf/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/nofiumoruf/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React",
        "⚡ Developing responsive website  using laravel (both frontend and backend) and vuejs",
        //"⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        //"⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        // {
        //   skillName: "Gatsby",
        //   fontAwesomeClassname: "simple-icons:gatsby",
        //   style: {
        //     color: "#663399",
        //   },
        // },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on Microsoft Azure and AWS",
      ],
      softwareSkills: [
        // {
        //   skillName: "GCP",
        //   fontAwesomeClassname: "simple-icons:googlecloud",
        //   style: {
        //     color: "#4285F4",
        //   },
        // },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        // {
        //   skillName: "Firebase",
        //   fontAwesomeClassname: "simple-icons:firebase",
        //   style: {
        //     color: "#FFCA28",
        //   },
        // },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        // {
        //   skillName: "MongoDB",
        //   fontAwesomeClassname: "simple-icons:mongodb",
        //   style: {
        //     color: "#47A248",
        //   },
        // },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        // {
        //   skillName: "Kubernetes",
        //   fontAwesomeClassname: "simple-icons:kubernetes",
        //   style: {
        //     color: "#326CE5",
        //   },
        // },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "LeetCode",
    //   iconifyClassname: "simple-icons:leetcode",
    //   style: {
    //     color: "#F79F1B",
    //   },
    //   profileLink: "https://leetcode.com/layman_brother/",
    // },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/nofiumoruf17",
    },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/nofiumorufpelumi",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Nigeria Nsukka",
      subtitle: "Bsc in Mathematics Eduaction(FIRST CLASS - 4.88/5.00)",
      logo_path: "UNN-removebg-preview (2).png",
      alt_name: "IIITDM Kurnool",
      duration: "2018 - 2023",
      descriptions: [
        "⚡ Graduated top 1% of the class with a strong foundation in pure and applied mathematics, education theories, and statistical analysis.",
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Conducted a comprehensive undergraduate thesis involving a 21-year statistical study comparing WAEC and NECO results, exploring gender disparities and the impact of different exam bodies on students' performance.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ Served as a dedicated academic tutor, mentoring students in Elementary Mathematics, Abstract Algebra, and Dynamics of Rigid Body throughout my undergraduate studies.",
        "⚡ Recipient of the Federal Government of Nigeria Bursary Award in recognition of academic excellence.",
      ],
      website_link: "http://unn.edu",
    },
    {
      title: "Corporate finance institute",
      subtitle: "Data Science and Machine Learning",
      logo_path: "CFI-removebg-preview.png",
      alt_name: "CFI",
      duration: "2020 - 2023",
      descriptions: [
        "⚡ Completed several certification programs including Business Intelligence & Data Analyst (BIDA), FMVA, and Machine Learning Fundamentals, applying Python and R for data modeling and analysis.",
        "⚡ Acquired hands-on experience in financial modeling, valuation, and machine learning techniques such as regression, clustering, and classification for real-world business solutions.",
        "⚡ Demonstrated data-driven decision-making and technical proficiency in Excel, SQL, Tableau, and Power BI through project-based learning and practical assignments.",
      ],
      website_link: "https://corporatefinanceinstitute.com/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- corporatefinanceinstitute",
      logo_path: "CFI-ML.png",
      certificate_link:
        "https://credentials.corporatefinanceinstitute.com/21721f08-5672-440a-8d04-2cb4298da4ff#acc.5ocifvxA",
      alt_name: "Corporate Finance Institute",
      color_code: "#8C151599",
    },
    {
      title: "AI & Machine Learning",
      subtitle: "FGN-ALAT Digital Skillnovation Program.",
      logo_path: "FGNXALAT_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1J4RwqmezwxbRDEKnmQxwd1ePTakVB0fF/view?usp=sharing",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Javascript Developer",
      subtitle: "- EITC The European Information Technologies",
      logo_path: "EITCI.png",
      certificate_link:
        "https://www.eitci.org/certificatesupplement?id=EITC/WD/JSF/PXE23004528&t=9dgHXGCWTCrdhF0R",
      alt_name: "EITC",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- corporatefinanceinstitute",
      logo_path: "CFI.png",
      certificate_link:
        "https://credentials.corporatefinanceinstitute.com/21721f08-5672-440a-8d04-2cb4298da4ff#acc.5ocifvxA",
      alt_name: "CFI",
      color_code: "#1F70C199",
    },
    {
      title: "Data Analytics",
      subtitle: "- Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/53N3GL6G52XR",
      alt_name: "google",
      color_code: "#D83B0199",
    },
    {
      title: "Intermediate Python Developer",
      subtitle: "- DataCamp",
      logo_path: "datacamp.png",
      certificate_link:
        "https://drive.google.com/file/d/1qqsp1BJNnAF5GzkIhNbERh2UWqOaxqLq/view",
      alt_name: "DataCamp",
      color_code: "#1F70C199",
    },
    {
      title: "HTML - CSS",
      subtitle: "- EITC The European Information Technologies",
      logo_path: "EITCI.png",
      certificate_link:
        "https://eitci.org/certificatesupplement?id=EITC/WD/HCF/YTE23004528&t=BwLmmv2dh60dHWjD",
      alt_name: "EITC",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- corporatefinanceinstitute",
      logo_path: "CFI.png",
      certificate_link:
        "https://credentials.corporatefinanceinstitute.com/24ed35f1-a25f-40e6-9c3d-e0c0b67aec57#acc.AMP4wXgN",
      alt_name: "CFI",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "ALT-SCHOOL",
      logo_path: "ALT.png",
      certificate_link:
        "https://drive.google.com/file/d/16ciVwrRuUeOtsePlFpESjlURo6F22GDa/view?usp=sharing",
      alt_name: "ALT-SCHOOL",
      color_code: "#2A73CC",
    },
    {
      title: "Wordpress Developer",
      subtitle: "- EITC The European Information Technologies",
      logo_path: "EITCI.png",
      certificate_link:
        "https://www.eitci.org/certificatesupplement?id=EITC/WD/WPF/PXF23004528&t=hMK9shJ7RZhTNffr",
      alt_name: "EITC",
      color_code: "#4285F499",
    },
    {
      title: "Google Project Management",
      subtitle: "- Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/DVH2LF69DQ3X",
      alt_name: "Google",
      color_code: "#FFBB0099",
    },
    {
      title: "SQL Developer",
      subtitle: "- corporatefinanceinstitute",
      logo_path: "CFI.png",
      certificate_link:
        "https://credentials.corporatefinanceinstitute.com/291f42bc-312a-4b04-9f02-531aa88da188#acc.0fQZB2oR",
      alt_name: "CFI",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
// const experience = {
//   title: "Experience",
//   subtitle: "Work, Internship and Volunteership",
//   description:
//     "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
//   header_image_path: "experience.svg",
//   sections: [
//     {
//       title: "Work",
//       work: true,
//       experiences: [
//         {
//           title: "Machine Learning Engineer",
//           company: "TikTok Inc.",
//           company_url: "https://www.tiktok.com/en/",
//           logo_path: "tiktok_logo.png",
//           duration: "June 2023 - Present",
//           location: "San Jose, CA, USA",
//           description:
//             "Improving ads ranking models on the core TikTok product. Experience working on modeling two-tower architectures like DeepFM, Wide & deep learning, etc. Working on Large Language Models (LLM) pretraining and Large Multi-modal Model (LMM) finetuning strategies.",
//           color: "#000000",
//         },
//         {
//           title: "Associate AI Engineer",
//           company: "Legato Health Technology",
//           company_url: "https://legatohealthtech.com/",
//           logo_path: "legato_logo.png",
//           duration: "June 2020 - Aug 2021",
//           location: "Hyderabad, Telangana",
//           description:
//             "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
//           color: "#0879bf",
//         },
//         {
//           title: "Android and ML Developer",
//           company: "Muffito Incorporation",
//           company_url: "https://www.linkedin.com/company/muffito-inc/about/",
//           logo_path: "muffito_logo.png",
//           duration: "May 2018 - Oct 2018",
//           location: "Pune, Maharashtra",
//           description:
//             "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
//           color: "#9b1578",
//         },
//         {
//           title: "Android Developer",
//           company: "FreeCopy Pvt. Ltd.",
//           company_url: "https://www.linkedin.com/company/freecopy/about/",
//           logo_path: "freecopy_logo.png",
//           duration: "Nov 2017 - Dec 2017",
//           location: "Ahmedabad, Gujarat",
//           description:
//             "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
//           color: "#fc1f20",
//         },
//       ],
//     },
//     {
//       title: "Internships",
//       experiences: [
//         {
//           title: "Machine Learning Intern",
//           company: "TikTok Inc.",
//           company_url: "https://www.tiktok.com/en/",
//           logo_path: "tiktok_logo.png",
//           duration: "May 2022 - Aug 2022",
//           location: "San Francisco, USA",
//           description:
//             "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
//           color: "#000000",
//         },
//         {
//           title: "Data Science Research Intern",
//           company: "Delhivery Pvt. Ltd.",
//           company_url: "https://www.delhivery.com/",
//           logo_path: "delhivery_logo.png",
//           duration: "May 2019 - Sept 2019",
//           location: "Gurgaon, Haryana",
//           description:
//             "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
//           color: "#ee3c26",
//         },
//         {
//           title: "Data Science Intern",
//           company: "Intel Indexer LLC",
//           company_url:
//             "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
//           logo_path: "intel_logo.jpg",
//           duration: "Nov 2018 - Dec 2018",
//           location: "Work From Home",
//           description:
//             "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
//           color: "#0071C5",
//         },
//       ],
//     },
//     {
//       title: "Volunteerships",
//       experiences: [
//         {
//           title: "Google Explore ML Facilitator",
//           company: "Google",
//           company_url: "https://about.google/",
//           logo_path: "google_logo.png",
//           duration: "June 2019 - April 2020",
//           location: "Hyderabad, Telangana",
//           description:
//             "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
//           color: "#4285F4",
//         },
//         {
//           title: "Microsoft Student Partner",
//           company: "Microsoft",
//           company_url: "https://www.microsoft.com/",
//           logo_path: "microsoft_logo.png",
//           duration: "Aug 2019 - May 2020",
//           location: "Hyderabad, Telangana",
//           description:
//             "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
//           color: "#D83B01",
//         },
//         {
//           title: "Mozilla Campus Captain",
//           company: "Mozilla",
//           company_url: "https://www.mozilla.org/",
//           logo_path: "mozilla_logo.png",
//           duration: "Oct 2019 - May 2020",
//           location: "Kurnool, Andhra Pradesh",
//           description:
//             "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
//           color: "#000000",
//         },
//         {
//           title: "Developer Students Club Member",
//           company: "DSC IIITDM Kurnool",
//           company_url:
//             "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
//           logo_path: "dsc_logo.png",
//           duration: "Jan 2018 - May 2020",
//           location: "Kurnool, Andhra Pradesh",
//           description:
//             "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
//           color: "#0C9D58",
//         },
//         {
//           title: "Developer Program Member",
//           company: "Github",
//           company_url: "https://github.com/",
//           logo_path: "github_logo.png",
//           duration: "July 2019 - PRESENT",
//           location: "Work From Home",
//           description:
//             "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
//           color: "#181717",
//         },
//       ],
//     },
//   ],
// };

const experience = {
  title: "Experience",
  subtitle: "Work, Internship, and Volunteership",
  description:
    "I have contributed to AI, web development, data analytics, and education across both startups and institutional roles. From deploying Groq-powered chatbots to leading full-stack Laravel projects and teaching data science, my experience bridges research, development, and impact-driven problem solving. I also mentor students and volunteer with sustainability and tech communities.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "AI Specialist & Full-Stack Laravel Developer",
          company: "Risk Control Academy",
          company_url: "https://riskcontrolacademy.com/",
          logo_path: "riskcontrol_logo.png",
          duration: "Jan 2025 – Present",
          location: "Lagos, Nigeria",
          description:
            "Led the development of an LLM-powered chatbot using Groq API and Laravel. Built secure API authentication via AWS IAM, deployed SSL monitoring systems, and created automated alerts. Contributed to Nigeria Risk Index platform and collaborated cross-functionally on full-stack infrastructure.",
          color: "#003366",
        },
        {
          title: "Web Developer & Digital Marketer",
          company: "Urbansgem Lifestyle",
          company_url: "https://www.instagram.com/p/Cz-6nrEiCys/?img_index=1",
          logo_path: "urbansgem_logo.png",
          duration: "Jan 2021 – Feb 2023",
          location: "Remote",
          description:
            "Managed Shopify storefront and social media ad campaigns. Boosted customer engagement and sales through Instagram/Facebook marketing and e-commerce optimization strategies.",
          color: "#E1306C",
        },
        {
          title: "Data Scientist and Tutor",
          company: "Expert-Hive Freelance Services",
          company_url: "https://www.experthivetutors.com/",
          logo_path: "experthive_logo.png",
          duration: "May 2024 – Jan 2025",
          location: "Remote",
          description:
            "Tutored advanced mathematics while delivering machine learning solutions using Python and R. Built dashboards and predictive models, and developed educational resources for global clients.",
          color: "#4B0082",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Scientist & Technical Support Intern",
          company: "Risk Control Services Nigeria Ltd.",
          company_url: "https://riskcontrolnigeria.com/",
          logo_path: "riskcontrol_logo.png",
          duration: "May 2024 – Sep 2024",
          location: "Lagos, Nigeria",
          description:
            "Analyzed national security and crime data, built dashboards, and automated workflows using Microsoft Power Automate. Created a SharePoint portal to streamline IT operations.",
          color: "#0879bf",
        },
        {
          title: "Data Analytics Intern",
          company: "Excelerate India",
          company_url: "https://experience.4excelerate.org/dashboard",
          logo_path: "excelerate_logo.png",
          duration: "Aug 2023 – Apr 2024",
          location: "Remote",
          description:
            "Built predictive models, analyzed cross-domain datasets, created visualizations, and supported business decisions using Excel, SQL, and Python.",
          color: "#ff6600",
        },
        {
          title: "Data Analyst Instructor",
          company: "TechProsNaija",
          company_url: "https://www.techprosnaija.com/",
          logo_path: "techprosnaija_logo.png",
          duration: "Feb 2024 – May 2024",
          location: "Remote",
          description:
            "Taught data cleaning, visualization, and analysis with Python, R, and SQL. Delivered interactive virtual sessions with real-world applications for Nigerian learners.",
          color: "#3333cc",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Data Analyst, NYSC Camp",
          company: "National Youth Service Corps (NYSC)",
          company_url: "#",
          logo_path: "nysc_logo.png",
          duration: "June 2024",
          location: "Afikpo, Ebonyi State",
          description:
            "Analyzed demographic data of over 1,000 corps members. Produced charts and insights for camp administration to inform key decisions.",
          color: "#006400",
        },
        {
          title: "UPG Sustainability Leader",
          company: "United People Global",
          company_url: "https://unitedpeople.global",
          logo_path: "upg_logo.png",
          duration: "May 2023 – Present",
          location: "Remote",
          description:
            "Promoted sustainable leadership initiatives and participated in impact-driven projects aligned with UPG’s global goals.",
          color: "#228B22",
        },
        {
          title: "Event Assistant & Data Manager",
          company: "Incubator Nigeria Bootcamp",
          company_url: "#",
          logo_path: "incubator_logo.png",
          duration: "May 2024",
          location: "RCCG Mowe, Ogun State",
          description:
            "Managed registration for over 1,000 participants using Google Sheets. Coordinated operations and resolved logistics in a high-pressure event environment.",
          color: "#008080",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A curated showcase of end-to-end projects spanning machine learning, cloud infrastructure, full-stack development, and data analytics — built with Python, React, Laravel, AWS, Power BI, and more.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

// const publications = {
//   data: [
//     {
//       id: "neuro-symbolic-sudoku-solver",
//       name: "Neuro-Symbolic Sudoku Solver",
//       createdAt: "2023-07-02T00:00:00Z",
//       description: "Paper published in KDD KiML 2023",
//       url: "https://arxiv.org/abs/2307.00653",
//     },
//     {
//       id: "mdp-diffusion",
//       name: "MDP-Diffusion",
//       createdAt: "2023-09-19T00:00:00Z",
//       description: "Blog published in Paperspace",
//       url: "https://blog.paperspace.com/mdp-diffusion/",
//     },
//     {
//       id: "consistency-models",
//       name: "Consistency Models",
//       createdAt: "2023-10-12T00:00:00Z",
//       description: "Blog published in Paperspace",
//       url: "https://blog.paperspace.com/consistency-models/",
//     },
//   ],
// };

const publications = {
  data: [
    {
      id: "faqs-chatbot-groq",
      name: "FAQs Chatbot using Groq API & Laravel",
      createdAt: "2025-04-06T00:00:00Z",
      description:
        "Deployed on Hugging Face Spaces — combines LLMs with secure Laravel backend.",
      url: "https://huggingface.co/spaces/nofiumoruf/FAQs_Chatbot",
    },
    {
      id: "from-equations-to-code",
      name:
        "From Equations to Code: My Journey into Data Science and Automation",
      createdAt: "2025-03-23T00:00:00Z",
      description:
        "Blog published on Hashnode — story of transitioning from math to data science.",
      url:
        "https://nofiumoruf.hashnode.dev/from-equations-to-code-my-journey-into-data-science-and-automation",
    },
    {
      id: "from-web-to-fullstack",
      name:
        "From Web Pages to Full-Stack Power: My Journey into Web Development",
      createdAt: "2025-04-04T00:00:00Z",
      description:
        "Blog published on Hashnode — highlights full-stack Laravel & chatbot projects.",
      url:
        "https://nofiumoruf.hashnode.dev/from-web-pages-to-full-stack-power-my-journey-into-web-development",
    },
  ],
};

// Contact Page
// const contactPageData = {
//   contactSection: {
//     title: "Contact Me",
//     profile_image_path: "animated_ashutosh.png",
//     description:
//       "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
//   },
//   blogSection: {
//     title: "Blogs",
//     subtitle:
//       "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
//     link: "https://blogs.ashutoshhathidara.com/",
//     avatar_image_path: "blogs_image.svg",
//   },
//   addressSection: {
//     title: "Address",
//     subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
//     locality: "San Jose",
//     country: "USA",
//     region: "California",
//     postalCode: "95129",
//     streetAddress: "Saratoga Avenue",
//     avatar_image_path: "address_image.svg",
//     location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
//   },
//   phoneSection: {
//     title: "",
//     subtitle: "",
//   },
// };

const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "pelumi.png", // Replace with your actual avatar image file name
    description:
      "I'm open to collaboration, research, mentorship, and technical problem-solving opportunities. Feel free to reach out via email or connect with me on GitHub or LinkedIn. I respond within 24–48 hours.",
  },
  blogSection: {
    title: "My Blog",
    subtitle:
      "I write about my journey through data science, AI, and full-stack development—sharing lessons from real-world projects and technical deep dives.",
    link: "https://nofiumoruf.hashnode.dev",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "Lagos, Nigeria",
    locality: "Lagos",
    country: "Nigeria",
    region: "Lagos State",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/CG5dftNDzF1BdFEE8", // Lagos, Nigeria
  },
  phoneSection: {
    title: "Email",
    subtitle: "nofiumoruf17@gmail.com",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
